import { useEffect, useRef, useState } from 'react';
import { useWindowSize } from '../../../hooks';
import type { UseHeightResult } from './types';

export function useHeight(visible: boolean): UseHeightResult {
  const [height, setHeight] = useState(600);
  const { height: windowHeight } = useWindowSize();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current == null) {
      return;
    }

    const { top } = ref.current.getBoundingClientRect();
    setHeight(windowHeight - top - 120);
  }, [visible, windowHeight]);

  return { height, ref };
}
